import { Builder } from "@builder.io/react";
import { BuilderElement } from "@builder.io/sdk";

import { BuilderTabs } from "./BuilderTabs";

const defaultTabContent: BuilderElement = {
  "@type": "@builder.io/sdk:Element",
  layerName: "Tab content",
  children: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Typography",
        options: {
          textContent:
            "This is the tab content. You can add any components here.",
          variant: {
            mobileAndAbove: "displaySSerifRegular",
            tabletAndAbove: "displaySSerifRegular",
          },
        },
      },
    },
  ],
};

export const registerBuilderTabs = () => {
  Builder.registerComponent(BuilderTabs, {
    name: "Tabs",
    hideFromInsertMenu: false,
    noWrap: true,
    canHaveChildren: true,
    inputs: [
      {
        name: "defaultActiveTab",
        type: "number",
        defaultValue: 0,
        helperText:
          "Index of the tab that should be active by default (0-based)",
      },
      {
        name: "tabHeaderLayout",
        type: "string",
        enum: ["flex-start", "flex-end", "center"],
        defaultValue: "flex-start",
        helperText: "Alignment of tab headers",
      },
      {
        name: "activeTabStyle",
        type: "object",
        helperText: "Custom styles for the active tab button",
        advanced: true,
      },
      {
        name: "tabs",
        type: "list",
        broadcast: true,
        subFields: [
          {
            name: "label",
            type: "string",
            required: true,
            localized: true,
          },
          {
            name: "content",
            type: "uiBlocks",
            defaultValue: [defaultTabContent],
          },
        ],
        defaultValue: [
          {
            label: "Tab 1",
            content: [defaultTabContent],
          },
          {
            label: "Tab 2",
            content: [defaultTabContent],
          },
        ],
      },
    ],
  });
};
